// extracted by mini-css-extract-plugin
export default {"buttonsWrapper":"BackButton_buttonsWrapper__O5ai1"};